import React from 'react';
import './Spinner.css';

const Spinner = () => {
    return (
        <div class="loader d-flex align-center justify-content-center"></div>
    );
};

export default Spinner;